import { Input } from 'framework7-react';
import { useEffect, useState } from 'react';

import dayjs from 'dayjs';

import { useCurrentUser } from '@queries/UserQueries';

import { useUpdateProfileMutation } from '@mutations/UserMutations';

import { useAnalytics } from '@hooks/useAnalytics';

import Button from '@components/buttons/Button';
import { Popup } from '@components/layout/Popup/Popup';
import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

export const AgeGate = () => {
  const { currentUser } = useCurrentUser();
  const [selectedDate, setSelectedDate] = useState<string>();
  const { track } = useAnalytics();
  const { isSubmitting, updateProfileAsync } = useUpdateProfileMutation();

  useEffect(() => {
    if (currentUser?.isAgeGateVisible) {
      track(`Age gate opened`, {});
    }
  }, [currentUser?.isAgeGateVisible]);

  const isUnder21 = selectedDate ? dayjs().diff(selectedDate, 'year') < 21 : false;
  const isOver21 = selectedDate ? !isUnder21 : false;

  const handleContinue = async () => {
    track(`Age submitted`, {
      dob: selectedDate,
    });

    await updateProfileAsync({
      dateOfBirth: selectedDate,
    });
  };

  return (
    <Popup height="half" isVisible={currentUser?.isAgeGateVisible} disableClose onClose={() => {}}>
      <Popup.Content>
        <TitleToolbar className="mt-3" text="Enter your birthdate" size="md" />
        <p className="mt-2 mb-4">
          <strong>Gaggl</strong> is committed to responsible drinking. You must be at least 21 use
          the app.
        </p>
        <Input
          style={{ minWidth: 130 }}
          type="datepicker"
          placeholder="Birthdate"
          calendarParams={{
            closeOnSelect: true,
            openIn: 'popover',
            on: {
              change(_, value: Date[] = []) {
                const date = value[0];
                const formattedDate = dayjs(date).format('YYYY-MM-DD');
                setSelectedDate(formattedDate);
              },
            },
          }}
        />
        <div className="mt-2">
          <Button roundness="rounded" onClick={handleContinue} disabled={!isOver21 || isSubmitting}>
            Continue
          </Button>
        </div>
        {isUnder21 && (
          <div className="mt-3 text-align-center text-color-red">
            You must be at least 21 years old to use Gaggl. Please come back when you are of legal
            drinking age.
          </div>
        )}
      </Popup.Content>
    </Popup>
  );
};
